"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const ArrowRightMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "16px",
  height: "16px",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("path", {
  d: "M15,4.25 L22.7071068,11.9571068 L15,19.6642136 L14.2928932,18.9571068 L20.792,12.457 L2,12.4571068 L2,11.4571068 L20.792,11.457 L14.2928932,4.95710678 L15,4.25 Z"
})));
var _default = exports.default = ArrowRightMDS;